import { useQuery } from "@tanstack/react-query"
import { getMyKpiReport } from "api/employeeKpiApi"

export const useMyKpiReport = (month, year) => {
  return useQuery({
    queryKey: ["my-kpi-report", month, year],
    queryFn: () => getMyKpiReport({ month, year }),
    staleTime: 1000 * 60 * 5,
  })
}
